<template>
<div class='summary'>
  <div class='pane'>
    <!-- <p>浏览量</p> -->
    <table class='browse-count-table'>
      <tr>
        <th>昨日浏览量</th>
        <th>今日浏览量</th>
        <th>总浏览量</th>
      </tr>
      <tr>
        <td>{{summary.pv.yesterday}}</td>
        <td>{{summary.pv.today}}</td>
        <td>{{summary.pv.total}}</td>
      </tr>
    </table>
  </div>
  <div class='pane'>
    <p>来源统计</p>
    <el-radio-group class='selector' v-model="tag">
      <el-radio-button label="today">今天</el-radio-button>
      <el-radio-button label="yesterday">昨天</el-radio-button>
      <el-radio-button label="total">总计</el-radio-button>
    </el-radio-group>

    <div class='pv-percentage-chart chart-wrapper' v-if="pvPercentageData">
      <bar-chart :data="pvPercentageData[tag]" :min="0" :library="pvPercentageOptions"></bar-chart>
      <p class='hint'>用户阅读来源统计</p>
    </div>

    <div class='actions-chart chart-wrapper' v-if="behaviorData">
      <column-chart class='actions-chart' :data="behaviorData[tag]" :library="behaviorOptions" :min="0"></column-chart>
      <p class='hint'>用户分享行为统计</p>
    </div>
  </div>
  <div class='pane'>
    <p>浏览量走势</p>
    <line-chart class='pv-chart' :data="trendData" :min="0" :library="pvChartOptions" v-if="trendData"></line-chart>
  </div>
</div>
</template>

<i18n>
{
  "zh-cn": {
    "pv_by_source": {
      "singlemessage": "朋友转发",
      "timeline": "朋友圈",
      "groupmessage": "群转发",
      "other": "其他",
      "course": "课程中心",
      "knowledge": "资料中心",
      "total": "总计"
    },
    "shares_by_target": {
      "sendappmessage": "微信好友",
      "sharetimeline": "朋友圈",
      "shareqq": "QQ好友",
      "other": "其他"
    }
  }
}
</i18n>

<script>
import { dynamicImportChartkick } from '@/assets/scripts/charts.js'

export default {
  components: {
    'bar-chart': () => dynamicImportChartkick('BarChart'),
    'column-chart': () => dynamicImportChartkick('ColumnChart'),
    'line-chart': () => dynamicImportChartkick('LineChart')
  },
  data: () => {
    return {
      tag: 'today',
      summary: {
        pv: {
          today: 0,
          total: 0,
          yesterday: 0
        }
      },
      pv_by_source: null,
      shares_by_target: null,
      pvPercentageOptions: {
        tooltips: {
          callbacks: {
            label: (item, data) => `浏览次数: ${item.xLabel}`
          }
        },
        scales: {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            barThickness: 30,
            gridLines: {
              display: false
            }
          }]
        }
      },
      pvChartOptions: {
        tooltips: {
          callbacks: {
            title: (item, data) => {
              return new Date(item[0].xLabel).toLocaleDateString(process.env.LOCALE)
            }
          }
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              displayFormats: {
                day: 'YYYY-MM-DD'
              },
              unit: 'day'
            }
          }]
        }
      },
      behaviorOptions: {
        tooltips: {
          callbacks: {
            label: (item, data) => `分享次数: ${item.yLabel}`
          }
        },
        scales: {
          xAxes: [{
            barThickness: 30
          }]
        }
      }
    }
  },
  computed: {
    pvPercentageData() {
      // total, yesterday, today
      let vm = this
      if (!vm.pv_by_source) {
        return false
      }

      let keys = Object.keys(vm.pv_by_source)
      let result = {}
      let tags = ['today', 'yesterday', 'total']

      tags.forEach(tag => {
        result[tag] = keys.map(k => {
          return [vm.$t(`pv_by_source.${k}`), vm.pv_by_source[k][tag]]
        })
      })

      return result
    },
    behaviorData() {
      let vm = this
      if (!vm.shares_by_target) {
        return false
      }

      let keys = Object.keys(vm.shares_by_target)
      let result = {}
      let tags = ['today', 'yesterday', 'total']

      tags.forEach(tag => {
        result[tag] = keys.map(k => {
          return [vm.$t(`shares_by_target.${k}`), vm.shares_by_target[k][tag]]
        })
      })

      return result
    },
    trendData() {
      let vm = this
      let pvs = this.pv_by_source
      if (!pvs) {
        return
      }
      let total = {}
      let result = Object.keys(pvs).map(function(source) {
        return {
          name: vm.$t(`pv_by_source.${source}`),
          data: Object.keys(pvs[source]['by_date']).map(function(date) {
            // date format is 20170101 need to parse into a date
            let dateInFormat = new Date(date.substr(0, 4), date.substr(4, 2) - 1, date.substr(6, 2))
            let pv = pvs[source]['by_date'][date]

            total[dateInFormat] = pv + (total[dateInFormat] || 0)

            return [dateInFormat, pv]
          })
        }
      })

      result.push({
        name: vm.$t(`pv_by_source.total`),
        data: Object.entries(total)
      })
      return result
    }
  },
  mounted() {
    let vm = this
    vm.$store.dispatch('project/stats', vm.$route.params.id).then(res => {
      vm.summary = res.data.summary
      vm.pv_by_source = res.data.pv_by_source
      vm.shares_by_target = res.data.shares_by_target
    })
  }
}
</script>

<style lang='scss' scoped>
.summary {
    .selector {
        position: absolute;
        right: 20px;
        top: 20px;
    }

    .chart-wrapper {
        float: left;
        padding: 20px 20px 0;
        width: 50%;

        .hint {
            text-align: center;
            color: $font-color-strong;
        }
    }

    .browse-count-table {
        text-align: center;
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// summary.view.vue?e32f7292